import React, { useState, useEffect } from "react";
import axios from "axios";

import LiveIcon from "../../../assets/images/AdminLiveProfile/live 1.png";
import { Link } from "react-router-dom";
import PromoFile from "../../SuperStar/PromoVideo/PromoFile";
import PromoAdminNav from "../../../Layouts/Partial/PromoAdminNav";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const AllPromoVideos = () => {
  const [event, setEvents] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get(`/api/admin/promoVideo/all`).then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.promoVideos);
      }
    });
  }, []);

  return (
    <>
      <PromoAdminNav />
      {buffer ? (
        <LoaderPost />
      ) : (
        <>
          {event.length > 0 ? (
            <>
              <div className="card card-bg head-line mb-2">
                <div className="text-light d-flex justify-content-center p-2">
                  <div className="faTrophy">
                    <i className="fas fa-trophy"></i>
                  </div>
                  <h4 className="mx-3 text-white p-2">
                    <span className="livechat-card-small">
                      All Promo Videos
                    </span>
                  </h4>
                </div>
              </div>

              <div className="row ">
                <PromoFile data={event} />
              </div>
            </>
          ) : (
            <div className="">
              <div className="card card-bg head-line mt-4 mb-2">
                <h5 className="text-light text-center">
                  <img src={LiveIcon} alt="" className="img-fluid mx-2 p-2" />{" "}
                  Promo Video
                </h5>
              </div>
              <div className=" text-center bg-dark p-2 mt-2">
                <i
                  style={{ color: "#ffc107" }}
                  className="fas fa-box-open fa-4x my-2"
                ></i>
                <h2 className="fw-bold text-light">No Data here</h2>
                <h5 className="text-light my-3">
                  Create Default Promo Video Now!
                </h5>
                <p className=" my-2 text-muted">
                  {/* Lorem ipsum dolor sit, amet consectetur adipisicing elit. */}
                </p>
                <Link to="/superstar-admin/upload/promoVideo">
                  <button className=" btn bottom-rightPost text-dark btn-warning my-5 px-5 fw-bold AnimateBtn px-4 py-1">
                    <span className="pTd">Create Now</span>
                  </button>
                </Link>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default AllPromoVideos;
